<label class="form-field--horizontal">
  @if (label) {
    <span class="header">{{label}}</span>
  }
  <span class="app-checkbox">
    <input type="checkbox" [formControl]="control"><span class="inner"></span>
  </span>
</label>
